<template>
  <div class="video-register">
    <div class="container">
      <div>
        <div class="row mb-50">
          <div>
            <div v-html="$t('videoRegister')" class="title"></div>
            <div class="body-content">
              <video controls controlsList="nodownload">
                <source src="../assets/registro-de-medicos.mp4" type="video/mp4" />
              Tu navegador no soporta la visualización de vídeo.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../plugins/i18n.js'
export default {
  name: 'VideoRegister',
  data: () => ({
    loaded: false
  }),
  computed: {
    getLanguage () {
      return i18n.locale
    }
  },
  mounted () {
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.video-register {
  width: 100%;
  background: #f7f9ff;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    height: 100%;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    text-align: left;

    .row {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        width: 100%;

        .title {
          font-size: 36px;
          font-weight: 700;
          color: #444d67;
          margin-bottom: 45px;
          text-align: center;
        }

        .body-content {
          width: 100%;

          > video {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }

  @media(max-width: 1100px) {
    .container {
      .row > div .title {
        font-size: 32px;
      }
    }
  }

  @media(max-width: 900px) {
    .container {
      .row > div .title {
        font-size: 28px;
        margin-bottom: 30px;
      }
    }
  }

  @media(max-width: 825px) {
    .container {
      .row > div .title {
        font-size: 28px;
        margin-bottom: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/video-register.vue